const channelEvents = {
  STAGE_PARTICIPANT_KICKED: 'STAGE_PARTICIPANT_KICKED',
  STAGE_REQUEST_TO_JOIN: 'STAGE_REQUEST_TO_JOIN',
  STAGE_HOST_ACCEPT_REQUEST_TO_JOIN: 'STAGE_HOST_ACCEPT_REQUEST_TO_JOIN',
  STAGE_HOST_DELETE_REQUEST_TO_JOIN: 'STAGE_HOST_DELETE_REQUEST_TO_JOIN',
  STAGE_REVOKE_REQUEST_TO_JOIN: 'STAGE_REVOKE_REQUEST_TO_JOIN',
  HOST_REMOVES_PARTICIPANT_SCREEN_SHARE: 'HOST_REMOVES_PARTICIPANT_SCREEN_SHARE'
};

export default channelEvents;
